export const paymentQueryKeys = {
  all: ['payment'] as const,
  confirm: (orderId: string) => [...paymentQueryKeys.all, 'confirm', orderId] as const,
  history: () => [...paymentQueryKeys.all, 'history'] as const,
  detail: (orderId: string) => [...paymentQueryKeys.all, 'detail', orderId] as const,
}
